import React, { useMemo } from 'react'
import StyledText from '../../../../StyledText'
import { View, TouchableOpacity, Linking, Platform } from 'react-native'
import styles from './ButtonCTAStyles'
import { useNavigation } from '@react-navigation/native'
import { onClickRedirect } from '../Go_to'
import { debug, info, warn } from '../../../utils/logger'

// Admite dos modos:
// 1) posts: objeto completo del post (legacy). Usa posts.go_to si existe, o posts.link_share
// 2) url/text/style_type: para el nuevo campo cta_button
const ButtonCTA = ({ posts, url, text, style_type }) => {
    let navigation = null
    try { navigation = useNavigation() } catch (e) {
        if (Platform.OS === 'web') {
            navigation = { navigate: () => {}, goBack: () => {}, getCurrentRoute: () => ({}) }
        } else { throw e }
    }

    // Derivar label a mostrar
    const label = text
        || posts?.cta_button?.text
        || posts?.text_link_share
        || 'Ver más'

    // Resolver si hay un go_to interno disponible directamente en el post
    const internalGoTo = posts?.go_to && typeof posts.go_to === 'object' ? posts.go_to : null

    // Parser simple para URL internas en cta_button.url o url prop
    const parsedGoTo = useMemo(() => {
        const raw = url || posts?.cta_button?.url || ''
        if (!raw || typeof raw !== 'string') return null
        const s = raw.trim()

        // Formatos soportados:
        // - course:ID
        // - internal://course/ID
        // - /learning/course/ID
        // - go_to:course:ID
        const courseMatch = s.match(/^(?:go_to:|internal:\/\/)?course:?([A-Za-z0-9_-]+)/i)
        if (courseMatch && courseMatch[1]) {
            return { type: 'interno', path: 'course', id_content: courseMatch[1] }
        }
        const coursePath = s.match(/\/course\/([A-Za-z0-9_-]+)/i)
        if (coursePath && coursePath[1]) {
            return { type: 'interno', path: 'course', id_content: coursePath[1] }
        }
        // Extender aquí otros patrones internos si es necesario
        return null
    }, [url, posts?.cta_button?.url])

    const handlePress = async () => {
        try {
            // 1) Preferir navegación interna via go_to del post
            if (internalGoTo && internalGoTo.type === 'interno') {
                return onClickRedirect(internalGoTo, navigation)
            }
            // 2) Si el cta_button.url (o prop url) parece interno, navegar internamente
            if (parsedGoTo) {
                return onClickRedirect(parsedGoTo, navigation)
            }
            // 3) Fallback: abrir link externo (legacy)
            const link = url || posts?.cta_button?.url || posts?.link_share
            if (link) {
                // Web: detectar PDF y descargar + abrir en nueva pestaña
                if (Platform.OS === 'web') {
                    const lower = String(link).toLowerCase()
                    if (lower.endsWith('.pdf')) {
                        info('CTA', '[FIX CTA] Web PDF detected in ButtonCTA, downloading:', link)
                        try {
                            const res = await fetch(link)
                            const blob = await res.blob()
                            const blobUrl = URL.createObjectURL(blob)
                            // Disparar descarga
                            const a = document.createElement('a')
                            a.href = blobUrl
                            const name = link.split('/').pop() || 'archivo.pdf'
                            a.download = name
                            document.body.appendChild(a)
                            a.click()
                            document.body.removeChild(a)
                            // Abrir en nueva pestaña
                            window.open(blobUrl, '_blank', 'noopener')
                            // Revocar luego de un tiempo
                            setTimeout(() => URL.revokeObjectURL(blobUrl), 60_000)
                            return
                        } catch (err) {
                            warn('CTA', '[FIX CTA] PDF fetch failed, opening direct URL:', err?.message)
                            try { window.open(link, '_blank', 'noopener') } catch {}
                            return
                        }
                    }
                    // No es PDF: abrir en nueva pestaña directamente
                    try { window.open(link, '_blank', 'noopener') } catch { return Linking.openURL(link) }
                    return
                }
                // Nativo
                return Linking.openURL(link)
            }
        } catch (e) {
            warn('CTA', '[ButtonCTA] Error handling CTA:', e?.message)
        }
    }

    return (
        <TouchableOpacity onPress={handlePress}>
            <View style={styles.ctaBarPost}>
                <StyledText fontSize='normalText' color='secondary'>
                    {label}
                </StyledText>
            </View>
        </TouchableOpacity>
    )
}

export default ButtonCTA
